import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ⬅️ hinzufügen
import '../styles/sonstige/feedback-text.css';

function Feedback_text() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        rating: 0
    });

    const [status, setStatus] = useState(null);
    const navigate = useNavigate(); // ⬅️ für Zurückfunktion

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);
        try {
            const res = await fetch('https://nurleder.de/api/feedback-text/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'omit'
            });
            const data = await res.json();
            if (res.ok) {
                setStatus({ success: true, message: data.message || 'Nachricht erfolgreich gesendet ✅' });
                setFormData({ name: '', email: '', subject: '', message: '', rating: 0 });
            } else {
                setStatus({ success: false, message: data.error || '❌ Fehler beim Senden.' });
            }
        } catch (err) {
            console.error('❌ Netzwerkfehler:', err);
            setStatus({ success: false, message: '❌ Netzwerkfehler. Bitte erneut versuchen.' });
        }
    };

    return (
        <div className="contact-form-container">
            <h2>Ihre Meinung zählt</h2>
            <p>Teilen Sie Ihre Erfahrung mit unseren Produkten – und helfen Sie anderen Kundinnen und Kunden!</p>

            <form onSubmit={handleSubmit} className="contact-form">
                <input type="text" name="name" placeholder="Ihr Name" value={formData.name} onChange={handleChange} required />
                <input type="email" name="email" placeholder="Ihre E-Mail-Adresse" value={formData.email} onChange={handleChange} required />
                <input type="text" name="subject" placeholder="Betreff" value={formData.subject} onChange={handleChange} required />
                <textarea name="message" placeholder="Ihre Nachricht..." value={formData.message} onChange={handleChange} rows={6} required />

                <div className="rating-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star} className={formData.rating >= star ? 'star selected' : 'star'} onClick={() => setFormData(prev => ({ ...prev, rating: star }))}>
                            ★
                        </span>
                    ))}
                </div>

                {formData.rating > 0 && (
                    <p className="rating-text">Bewertung: {formData.rating} von 5</p>
                )}

                <div className="button-row">
                    <button type="submit" className="submit-btn">Absenden</button>
                    <button type="button" className="back-btn" onClick={() => navigate('/feedback')}>Zurück</button>
                </div>

                {status && (
                    <p className={`status-message ${status.success ? 'success' : 'error'}`}>
                        {status.message}
                    </p>
                )}
            </form>
        </div>
    );
}

export default Feedback_text;
